import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { monitorService } from "./service";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;
type SetCoverageOnInsuranceCoverageMonitorRequest =
  insuranceMonitorApiSpec.operations["setCoverageOnInsuranceCoverageMonitor"]["requestBody"]["content"]["application/json"];

export const setCoverageOnInsuranceCoverageMonitor = async (
  insuranceCoverageMonitorId: string,
  request: SetCoverageOnInsuranceCoverageMonitorRequest
): Promise<InsuranceCoverageMonitor> => {
  const { data } = await monitorService.patch<InsuranceCoverageMonitor>(
    `/${insuranceCoverageMonitorId}`,
    request
  );

  return data;
};
